/**
 * Created by Administrator on 2017-11-27.
 */
export function changehosArea(val) {
  let hosArea;
  if (val == 0) {
    hosArea = '解放院区'
  }
  if (val == 4) {
    hosArea = '滨江院区'
  }
  return hosArea;
}

export function changeSex(val) {
  let sex;
  val == '男' ? sex = '1' : sex = '0';
  return sex;
}

export function changeGender(val) {
  let gander;
  val.replace(/\s+/g, "") == "F" ? gander = '女' : gander = '男';
  return gander;
}

/*export function changeAge(val){
  let unit=val.substr(-1,1)
  let age;
  if(unit == "天"){age = "1"}
  else if(unit == "周"){age = "2"}
  else if(unit == "月"){age = "3"}
  else if(unit == "小时"){age = "5"}
  else{age = "4"}
  return age;
}*/
export function changeAge(val) {
  let age;
  if (val == 1) {
    age = "天"
  } else if (val == "2") {
    age = "周"
  } else if (val == "3") {
    age = "月"
  } else if (val == "5") {
    age = "小时"
  } else {
    age = "岁"
  }
  return age;
}

export function changecheckType(val) {
  let checkType = val.join(',');
  checkType = checkType.split(',');
  let index = checkType.indexOf("DX/DR/CR");
  if (index > -1) {
    checkType.splice(index, 1);
    checkType.push('DX', 'DR', 'CR')
  }
  return checkType;
}

export function yinyang(val) {
  if (val == 1) {
    return "阳性";
  } else if (val == 0) {
    return "阴性"
  } else {
    return "无"
  }
}

export function changeclinicType(val) {
  let clinicType;
  if (val == "10") {
    clinicType = '住院'
  } else if (val == "50") {
    clinicType = '门诊'
  } else if (val == "60") {
    clinicType = '急诊'
  } else if (val == "70") {
    clinicType = '体检'
  } else if (val == "90") {
    clinicType = '预约'
    // } else if (val == "99") {
    //   clinicType = '其他'
  } else {
    clinicType = '其他'
  }
  return clinicType;
}


export function changeteachType(val) {
  let teachType
  if (val == '1') {
    teachType = '直播授课'
  } else if (val == '2') {
    teachType = '自主学习'
  }
  return teachType
}


export function onShelfState(val) {
  let onShelf
  if (val == '1') {
    onShelf = '未上架'
  } else if (val == '2') {
    onShelf = '已上架'
  }
  return onShelf
}

export function changecourseType(val) {
  let courseTypeId
  if (val == '1') {
    courseTypeId = '专题讲座'
  } else if (val == '2') {
    courseTypeId = '行业基础'
  } else if (val == '3') {
    courseTypeId = '课题研究'
  } else if (val == '4') {
    courseTypeId = '经验分享'
  }
  return courseTypeId
}

export function courseStates(val) {
  let courseState
  if (val == '1') {
    courseState = '已保存'
  } else if (val == '2') {
    courseState = '未开始'
  } else if (val == '3') {
    courseState = '进行中'
  } else if (val == '4') {
    courseState = '已结束'
  } else if (val == '0') {
    courseState = ' '
  }
  return courseState
}



export function unhtml(str) { //<>和引号转义问题
  return str ? str.replace(/[<">']/g, (a) => {
    return {
      '<': '&lt;',
      '"': '&quot;',
      '>': '&gt;',
      "'": '&#39;'
    }[a]
  }) : '';
}



// WEBPACK FOOTER //
// ./src/common/js/change.js